module.exports = __webpack_public_path__ + "img/ico_shenqi.1871a47f.png";